import React from 'react';
import { useAuthentication } from '../../contexts/AuthContext';

interface EmailVerifiedRouteProps {
  children: React.ReactNode;
}

const EmailVerifiedRoute: React.FC<EmailVerifiedRouteProps> = ({ children }) => {
  const { isEmailVerified } = useAuthentication();

  if (!isEmailVerified) {
    return (
      <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center">
        <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 space-y-4 text-center">
          <div className="text-yellow-500 text-5xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Email Verification Required</h2>
          <p className="text-gray-600">
            Please verify your email address to access this page. Check your inbox for the verification code.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default EmailVerifiedRoute; 